import { render, staticRenderFns } from "./HomeHeroVideo.vue?vue&type=template&id=70b1f70a&"
import script from "./HomeHeroVideo.vue?vue&type=script&lang=js&"
export * from "./HomeHeroVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports